import { FormattedMessage } from 'react-intl';

import { RivalsLightning } from '@sorare/core/src/components/rivals/RepScore/RivalsLightning';
import { navLabels } from '@sorare/core/src/lib/glossary';

import { Block } from '../Block';

export type Props = {
  records: {
    wins: number;
    draws: number;
    losses: number;
  };
  noPadding?: boolean;
  hideHeader?: boolean;
};

export const Rivals = ({
  records,
  children,
  noPadding,
  hideHeader,
}: React.PropsWithChildren<Props>) => {
  const total = records.wins + records.draws + records.losses;

  return (
    <Block
      noPadding={noPadding}
      hideHeader={hideHeader}
      title={<FormattedMessage {...navLabels.rivals} />}
      icon={<RivalsLightning fill="var(--c-neutral-1000)" />}
      stat={{
        count: total,
        label: (
          <FormattedMessage
            id="ManagerProfile.Rivals.matchesPlayed"
            defaultMessage="{count, plural, one {matchup} other {matchups}} played"
            values={{ count: total }}
          />
        ),
      }}
    >
      {children}
    </Block>
  );
};
